import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { setTimeout } from 'timers';
import AppBarResponsiveButton from '@/components/AppBarResponsiveButton.vue';
let ActionMenuButton = class ActionMenuButton extends Vue {
    finished;
    error;
    buttonText;
    buttonIcon;
    // eslint-disable-next-line no-prototype-builtins
    isTextButton = this.$attrs.hasOwnProperty('text');
    animationTimer = 2000;
    onFinished(val) {
        if (val) {
            setTimeout(() => {
                this.$emit('button-loader-finished');
            }, this.animationTimer);
        }
    }
    onError(val) {
        if (val) {
            setTimeout(() => {
                this.$emit('button-loader-error');
            }, this.animationTimer);
        }
    }
    classObjectSpan = {
        'font-weight-bold': !this.isTextButton,
        'primary--text': this.isTextButton
    };
};
__decorate([
    Prop({ type: Boolean, default: false, required: false })
], ActionMenuButton.prototype, "finished", void 0);
__decorate([
    Prop({ type: Boolean, default: false, required: false })
], ActionMenuButton.prototype, "error", void 0);
__decorate([
    Prop({ type: String, required: true })
], ActionMenuButton.prototype, "buttonText", void 0);
__decorate([
    Prop({ type: String, required: true })
], ActionMenuButton.prototype, "buttonIcon", void 0);
__decorate([
    Watch('finished')
], ActionMenuButton.prototype, "onFinished", null);
__decorate([
    Watch('error')
], ActionMenuButton.prototype, "onError", null);
ActionMenuButton = __decorate([
    Component({
        components: {
            AppBarResponsiveButton
        },
    })
], ActionMenuButton);
export default ActionMenuButton;
